import type { StylesConfig } from 'react-select'

const showAmountStyles: StylesConfig<any, false, any> = {
	control: (base, { menuIsOpen }) => {
		return {
			...base,
			'&:hover': {
				border: '1px solid var(--border-color)'
			},
			'--border-color': menuIsOpen ? '#0cb39f' : '#EBEDF2',
			background: '#FFF',
			border: '1px solid var(--border-color)',
			borderTopLeftRadius: 0,
			borderTopRightRadius: 0,
			boxShadow: '',
			color: '#202020',
			cursor: 'pointer',
			fontSize: 14,
			fontWeight: 400,
			minHeight: '32px',
			opacity: '1',
			width: '150px'
		}
	},

	dropdownIndicator: base => ({
		...base,
		color: '#202020',
		height: '32px',
		padding: '5px   3px'
	}),

	indicatorsContainer: base => ({
		...base,
		borderLeft: '1px solid var(--border-color)'
	}),
	indicatorSeparator: base => ({
		...base,
		backgroundColor: 'transparent',
		paddingBottom: '5px',
		paddingTop: '5px'
	}),
	menu: base => ({
		...base,
		borderTop: 0,
		borderTopLeftRadius: 0,
		borderTopRightRadius: 0,
		boxShadow: '',
		marginTop: 0
	}),
	menuList: base => ({
		...base,
		backgroundColor: '#fff',
		border: '1px solid #0cb39f',
		borderBottom: '1px solid transparent',
		bottom: '34px',
		left: '-1px',
		position: 'absolute',
		width: '150px'
	}),
	option: (styles, { isSelected }) => ({
		...styles,
		'&:active': {
			backgroundColor: 'transparent'
		},
		'&:hover': { backgroundColor: '#F7F7F7', cursor: 'pointer' },
		backgroundColor: isSelected ? '#F7F7F7' : 'transparent',
		color: '#000',
		fontSize: 14
	}),
	singleValue: base => ({
		...base
	}),
	valueContainer: provided => ({
		...provided,
		height: '32px'
	})
}

const SHOW_ITEMS = [10, 25, 50, 100].map(amount => ({
	label: `Show ${amount} items`,
	value: amount
}))

export { SHOW_ITEMS, showAmountStyles }
